module.exports = __webpack_public_path__ + "img/2c85c26.svg";